import { render, staticRenderFns } from "./SensorGraph.component.vue?vue&type=template&id=0c522fc7&scoped=true"
import script from "./SensorGraph.component.ts?vue&type=script&lang=js&external"
export * from "./SensorGraph.component.ts?vue&type=script&lang=js&external"
import style0 from "./SensorGraph.component.vue?vue&type=style&index=0&id=0c522fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c522fc7",
  null
  
)

export default component.exports